import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import { REPAYMENT_COLLECTION_TYPE } from "@app/utils";
import { formatIndianCurrency } from "@app/utils/utility";
import { CheckCircle, WarningCircle } from "@app/sharedComponents/Icons/Icons";

const BajajPaymentBreakup = ({paymentType,selectedAmount,interestDetails,shortFallDetails,principalOutStandingAmount}:any)=>{


    const {outstandingInterest = 0, month} = interestDetails;

    const paymentBreakdown = {
        interestPayment: 0,
        remainingInterest: 0,
        chargesPayment: 0,
        remainingCharges: 0,
        principalPayment: 0,
        remainingPrincipal: 0,
        showPrincipalPayment: false,
        showChargesPayment: false,
        showInterestPayment: false,
        isShortfallSettled: false,
        remainingShortfall: 0
    };

    let tempVal = selectedAmount;

    if(paymentType === REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT || paymentType === REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT){
        paymentBreakdown.showPrincipalPayment = true;
        paymentBreakdown.principalPayment = tempVal;
        paymentBreakdown.remainingPrincipal = (principalOutStandingAmount-tempVal);
    } else if(paymentType === REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION){
        paymentBreakdown.showInterestPayment = true;
        paymentBreakdown.interestPayment = tempVal;
        paymentBreakdown.remainingInterest = (outstandingInterest-tempVal);
        tempVal = 0;
    } 
    if(tempVal > 0) paymentBreakdown.showPrincipalPayment = true;
    if(tempVal >= shortFallDetails?.shortfallAmount){
        paymentBreakdown.isShortfallSettled = true;
    } else {
        paymentBreakdown.remainingShortfall = (shortFallDetails?.shortfallAmount-tempVal);
        paymentBreakdown.isShortfallSettled = false;
    }

    const {interestPayment,remainingInterest,showInterestPayment,showPrincipalPayment,principalPayment,remainingPrincipal,isShortfallSettled,remainingShortfall} = paymentBreakdown;
   
    return(
        <ThemedView px="md" pb="md" borderBottomLeftRadius="sm" borderBottomRightRadius="sm"  backgroundColor="bg-fill-primary">
            {(interestPayment > 0) && <ThemedView mt="md">
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3s" color="text-primary">
                        Towards interest due for {month}
                    </ThemedText>
                    <ThemedText variant="b3s" color="text-primary">
                        ₹{formatIndianCurrency(interestPayment)}
                    </ThemedText>
                </ThemedView>
                <ThemedText variant="b4r" color="text-secondary">
                    Remaining balance: ₹{formatIndianCurrency(remainingInterest)}
                </ThemedText>
            </ThemedView>}
            {principalPayment > 0 && <ThemedView mt="md">
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3s" color="text-primary">
                        Towards outstanding amount
                    </ThemedText>
                    <ThemedText variant="b3s" color="text-primary">
                        ₹{formatIndianCurrency(principalPayment)}
                    </ThemedText>
                </ThemedView>
                <ThemedText variant="b4r" color="text-secondary">
                    Remaining balance: ₹{formatIndianCurrency(remainingPrincipal)}
                </ThemedText>
            </ThemedView>}
            {(shortFallDetails?.shortfallAmount > 0) && (
                <ThemedView backgroundColor={isShortfallSettled ? "bg-fill-emphasis-secondary" :"bg-fill-error"}  mt="md" borderRadius="sm" alignItems="center" flexDirection="row" flex={1} flexWrap="wrap" px="md" py="sm">
                {isShortfallSettled ? 
                <CheckCircle weight="fill" color={themeColorSet["icon-success"]}/> :
                <WarningCircle weight="fill" color={themeColorSet["icon-error"]} /> 
                }
                <ThemedView flexDirection="row" ml="md">
                    <ThemedText variant="b4r" color="text-primary">
                        Shortfall amount of 
                    </ThemedText>
                    <ThemedText variant="b4b" color="text-primary">
                        {isShortfallSettled ? ` ₹${Number(shortFallDetails?.shortfallAmount)}` : ` ₹${Number(remainingShortfall).toFixed(2)}`}
                    </ThemedText>
                    <ThemedText variant="b4r" color="text-primary">
                        {isShortfallSettled ? ' will be settled' : ' is remaining'}
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        )}
        </ThemedView>
    )
}

export default BajajPaymentBreakup;